import { CSS, StyleProps } from "@shared/primitive-components"

export const titleContainer = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(4),
  backgroundColor: props.theme.palette.white,
  padding: props.theme.spacing(4, 0),
  paddingLeft: props.theme.spacing(6),
})

export const titleFlex = (hasPrevPolicyDropdown: boolean): CSS => ({
  display: hasPrevPolicyDropdown ? `flex` : `block`,
  justifyContent: `space-between`,
})

export const title = (): CSS => ({
  display: `flex`,
  justifyContent: `space-between`,
  alignItems: `center`,
  fontSize: `24px`,
})

export const bottomMargin = (props: StyleProps): CSS => ({
  marginBottom: `40px`,
  "@media (min-width: 768px)": {
    marginBottom: props.theme.spacing(8),
  },
})
